import { getTimeSince } from '@/lib/utils';

interface TProps {
	updatedAt?: Date | string;
	createdAt: Date | string;
	readonly?: boolean;
}

const PhotoVerificationGroupInfos = ({ createdAt, updatedAt, readonly }: TProps) => (
	<span className={'text-muted-foreground text-sm text-center'}>
		{
			!readonly
				? getTimeSince(createdAt, 'Vérification demandée')
				: getTimeSince(updatedAt!, 'Vérification effectuée')
		}
	</span>
);

export default PhotoVerificationGroupInfos;
